<!--<div class="not-found">-->
<!--  <img src="assets/error.png" alt="https://www.flaticon.com/free-icons/computer" height="512" width="512" class="image" priority>-->
<!--  &lt;!&ndash;<a href="https://www.flaticon.com/free-icons/computer" title="computer icons">Computer icons created by amonrat rungreangfangsai - Flaticon</a>&ndash;&gt;-->
<!--  <p>{{'SOMETHING_WENT_WRONG' | translate}}</p>-->
<!--  <p class="error-message">{{errorMessage}}</p>-->
<!--  <p>{{'RETURN_TO_DASHBOARD' | translate}}</p>-->
<!--  <button mat-stroked-button (click)="backToPage()">{{'YES' | translate}}</button>-->
<!--</div>-->

<div class="error-page-container">
  <img src="assets/error.png" alt="Error illustration" class="error-image" />

  <h2>{{ 'SOMETHING_WENT_WRONG' | translate }}</h2>
  <p class="error-message">{{ errorMessage }}</p>

  <p class="error-hint">{{ 'RETURN_TO_DASHBOARD' | translate }}</p>

  <button mat-fab extended="true" (click)="backToPage()">
    <mat-icon>home</mat-icon>
    {{ 'YES' | translate }}
  </button>
</div>
